import { registerPlugin } from '@capacitor/core';
const PrintV = registerPlugin('PrintV', {
    web: () => import('./web').then(m => new m.PrintVWeb()),
});
export * from './definitions';
export { PrintV };
//# sourceMappingURL=index.js.map